import { render, staticRenderFns } from "./fa_brief_tile.vue?vue&type=template&id=2833f908&scoped=true&"
import script from "./fa_brief_tile.vue?vue&type=script&lang=js&"
export * from "./fa_brief_tile.vue?vue&type=script&lang=js&"
import style0 from "./fa_brief_tile.vue?vue&type=style&index=0&id=2833f908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833f908",
  null
  
)

export default component.exports